// Imports => Constants
import { ENDPOINTS } from '@constants';

export class MenusAPI {
  constructor(Instance) {
    this.Store = Instance.Store;
    this.Client = Instance.Client;
  }

  list() {
    return this.Client.get(ENDPOINTS.MENUS.INDEX)
      .then((response) => response.data.data)
      .catch((error) => {
        throw error;
      });
  }
}

export default MenusAPI;
